import React from "react";
import { useSelector } from "react-redux";
import LeaveRequestsTeacher from "./teacher/LeaveRequestsTeacher";
import LeaveRequestsStudent from "./student/LeaveRequestsStudent";
import Loader from "./Loader.js";
import PermissionDenied from "./PermissionDenied.js";
import ClassesOnboarding from "./onboarding/ClassesOnboarding";
import LeaveRequestsPrincipal from "./principal/LeaveRequestsPrincipal";
import LeaveRequestsParent from "./parent/LeaveRequestsParent";

const LeaveRequests = () => {
  const state = useSelector((state) => state);

  if (state.auth.isLoading) {
    return <Loader />;
  } else {
    if (state.auth.user.is_teacher) {
      return <LeaveRequestsTeacher />;
    }
    if (state.auth.user.is_student) {
      return <LeaveRequestsStudent />;
    }
    if (state.auth.user.is_onboarding) {
      return <ClassesOnboarding />;
    }
    if (state.auth.user.is_principal) {
      return <LeaveRequestsPrincipal />;
    }
    if (state.auth.user.is_parent) {
      if (!state.auth.isLoadingStudent) {
        return <LeaveRequestsParent />;
      }
      return <Loader />;
    }
    return <PermissionDenied />;
  }
};

export default LeaveRequests;
